import styled from 'styled-components';
import Badge from '@mui/material/Badge';
import { StyledLink } from '../styles/ui';
import { HEADER_TYPE } from '../types';
import { fontRegular24, fontRegular16 } from '../styles/fonts';
import { Colors } from '../../../theme';
export const CustomNav = styled.nav `
  display: flex;
  display: ${(props) => (props.$type === HEADER_TYPE.Integrated ? 'none' : 'initial')};
  flex: 1;
  margin: 24px 0 180px;
`;
export const CustomSection = styled.section `
  flex: 1;
  padding: 0;
  margin: 0;
`;
export const CustomListItem = styled.li `
  display: flex;
  align-items: center;
  width: 100%;
  margin: 0;

  .avatarButton {
    &:hover {
      background-color: transparent;
    }
  }

  .avatarName {
    ${fontRegular16}
    color: ${Colors.blue60};
    background-color: ${Colors.blue10};
  }

  .avatarIcon {
    margin-left: 8px;
    color: ${Colors.black80};
    transform: rotate(-90deg);
  }
`;
export const CustomLink = styled(StyledLink) `
  flex: 1;
  display: flex;
  justify-content: space-between;
  align-items: center;
  ${fontRegular24}
  color: ${Colors.black80};

  &.MuiLink-root {
    &:hover,
    &:focus,
    &:active {
      color: ${(props) => (props.$isActive ? Colors.blue60 : Colors.black80)};
      text-decoration: none;
      background: none;
    }
  }

  .MuiSvgIcon-root {
    font-size: 30px;
  }
`;
export const CustomBadge = styled(Badge) `
  .MuiBadge-badge {
    right: -8px;
  }
`;
//# sourceMappingURL=styles.js.map